import { useEffect, useMemo, useState } from "react";
import CSS from "./static/css/modal.module.css";
import { createPortal } from "react-dom";

const Modal = (
    {
        isModalOpen,
        modalCloseHandler,
        classNameList,
        children,
    }:{
        isModalOpen: boolean;
        modalCloseHandler?: () => void;
        classNameList?: string[];
        children?: React.ReactNode;
    }
) => {

    const mainClassName = useMemo(() => {
        const RTN: string[] = [];

        if(!!classNameList){
            for(const class_name of classNameList){
                RTN.push(class_name);
            }
        }

        RTN.push(CSS.l_modal);

        return RTN.join(" ");
    }, [classNameList])

    const m_root_element = document.getElementById("root");

    const backBtnHandler = () => {
        if(modalCloseHandler){
            modalCloseHandler();
        }
    };

    if(isModalOpen){
        return createPortal((
            <div 
                className={mainClassName}
                onClick={backBtnHandler}
            >
                <div 
                    className={CSS.l_modal__children_container}
                    onClick={(event) => {
                        // 모달 본문 내용을 클릭했을때 backgroundClickEventHandler가 동작하는것을 막기 위해 이벤트의 전파를 차단함
                        event.stopPropagation();
                    }}
                >
                    {children}
                </div>
            </div>
        ), m_root_element || document.body)
    }else{
        return null;
    }
}

export default Modal